Vue.component('page-login', {
    mounted() {
        $('.styled').uniform();
    }
});